import React from "react";
import PropTypes from "prop-types";

const TableUserProfileView = ({
  src,
  title,
  description,
  imageDimenssion = [2 * 16, 2 * 16], //1rem = 16px
  className,
}) => {
  return (
    <div className={`flex-row align-center justify-start g-05 ${className}}`}>
      <img
        src={src}
        alt={new Date()}
        style={{
          width: `${imageDimenssion[0]}px`,
          height: `${imageDimenssion[1]}px`,
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      <div className="flex-col align-start justify-center">
        <h3 className="weight-500 poppins colorBlack t-15">{title}</h3>
        <span className="poppins t-11 color-grayColor">{description}</span>
      </div>
    </div>
  );
};

export default TableUserProfileView;
TableUserProfileView.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
  imageDimenssion: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.number])
  ).isRequired,
};
